// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginPage_wrapper__BJ90U"};